import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import vuetify from './plugins/vuetify';
import App from './App.vue'
import router from './router'

window.axios = require('axios');
axios.defaults.baseURL = 'https://app.qwertii.com/api'
// axios.defaults.baseURL = 'http://localhost:3000/api'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
